import 'swiper/css'

import { Link } from '@chakra-ui/next-js'
import { Box, Flex, Grid, GridItem, HStack, Image, Stack, StackProps } from '@chakra-ui/react'
import { LandingContainer } from 'components/common/LandingContainer'
import ServerHtmlDeferred from 'components/common/ServerHtmlDeferred'
import { NorthEastArrowCircle } from 'components/svg/NorthEastArrowCircle'
import { Body1, Body1Strong, H2 } from 'components/typography'
import { FC } from 'react'

const defaultCardsContents = [
  {
    title: 'Consulta sobre problemas sexuais',
    description:
      'Se algum aspecto da sua saúde sexual te preocupa \u2013 ou pode melhorar, marque uma conversa com um de nossos médicos, com total discrição.',
    imgSrc: '/landings/dr-joao.webp',
    href: '/consultar?origin=sexual-health'
  },
  {
    title: 'Programa <br/> Master',
    description:
      'Neste curso exclusivo, ministrado por um de nossos médicos, você terá acesso a um conteúdo com técnicas físicas e mentais para recuperar e melhor controlar suas ereções.',
    shortClip: '/academy/shortclip-master-audioless.mp4',
    href: '/cursos/programa-master'
  },
  {
    title: 'Consulta de <br/> psicologia',
    description:
      'Nem sempre a origem dos problemas sexuais é física. Em alguns casos, consultas com psicólogos especializados em sexualidade complementam seu tratamento.',
    imgSrc: '/landings/dr-gustavo.webp',
    href: '/consultar?origin=psychology'
  }
]

interface MayAlsoInterestYouSectionProps {
  cardsContents?: {
    title: string
    description: string
    shortClip?: string
    href: string
    imgSrc?: string
  }[]
  contentContainerProps?: StackProps
}

const MayAlsoInterestYouSection: FC<MayAlsoInterestYouSectionProps> = ({
  cardsContents = defaultCardsContents,
  contentContainerProps
}) => {
  return (
    <Box bg="alabaster">
      <LandingContainer
        pt={{
          base: '40px',
          lg: '96px'
        }}
      >
        <H2 mb={8} size="2xl" fontWeight="700">
          Conheça também
        </H2>
        <Grid
          templateColumns={{
            base: '1fr',
            lg: 'repeat(3, 1fr)'
          }}
          gap={8}
        >
          {cardsContents.map((card) => {
            return (
              <GridItem key={card.title}>
                <Link href={card.href}>
                  <Stack spacing={8} h="full">
                    {card.imgSrc ||
                      (card.shortClip && (
                        <Flex minH="220px" rounded="24px" overflow="hidden">
                          {card.shortClip ? (
                            <ServerHtmlDeferred>
                              <video
                                style={{
                                  height: '220px',
                                  objectFit: 'cover'
                                }}
                                autoPlay
                                loop
                                muted
                                playsInline
                              >
                                <source src={card.shortClip} type="video/mp4" />
                                Seu navegador não suporta o elemento de vídeo.
                              </video>
                            </ServerHtmlDeferred>
                          ) : card.imgSrc ? (
                            <Image alt={card.title} src={card.imgSrc} objectFit="cover" w="full" minH="220px" />
                          ) : (
                            <></>
                          )}
                        </Flex>
                      ))}

                    <Stack
                      h="full"
                      rounded="24px"
                      spacing={4}
                      bg="grayscale.20"
                      transition="background-color 0.2s"
                      _hover={{
                        bg: 'dandelion'
                      }}
                      p={{
                        base: 4,
                        lg: 8
                      }}
                      {...contentContainerProps}
                    >
                      <HStack justify="space-between" align="start">
                        <Body1Strong
                          fontSize="2xl"
                          lineHeight="normal"
                          dangerouslySetInnerHTML={{ __html: card.title }}
                        />
                        <NorthEastArrowCircle color="phthalo" boxSize="40px" />
                      </HStack>
                      <Body1 mb={2}>{card.description}</Body1>
                    </Stack>
                  </Stack>
                </Link>
              </GridItem>
            )
          })}
        </Grid>
      </LandingContainer>
    </Box>
  )
}

export default MayAlsoInterestYouSection
